import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackbarComponent, SnackbarVariants } from '../component/snackbar/snackbar.component';

@Injectable()
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  openSnackbar(header: string, message: string, variant: SnackbarVariants, duration: number = 3000) {
    const config: MatSnackBarConfig = {
      duration,
    };

    this.snackBar.openFromComponent(SnackbarComponent, {
      ...config,
      data: { header, message, variant },
    });
  }
}
